/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions } from "../../funcs/proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$inboundSchema,
};

export const tool$proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions:
  ToolDefinition<typeof args> = {
    name:
      "proposal-deadline-extensions-get-api-v3-id-deadline-extensions",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await proposalDeadlineExtensionsGetApiV3ProposalsProposalIdDeadlineExtensions(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
